import React, { useState } from "react";
import { ThemeProvider } from "styled-components";
import { Default } from "./theme/themes/Default";
import { Theme } from "./theme/types/themes";
import { AppRouter } from "./routes/routes";
// import { themeConfig } from "./store/selector";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import theme from "./mui-theme";
import { initializeAppInsights } from "@services/applicationInsights";
import { initializeGA } from "@services/googleAnalytics";
import { initializeClarity } from "@services/clarity";
import { useClarityPageTracking } from "@hooks/useClarityPageTracking";
import { ClickTracker } from "@components/ClickTracker/ClickTracker";
import { useSessionIdleTimeout } from "@hooks/useSessionIdleTimeout";
import { useAppVersionCheck } from "@hooks/useAppVersionCheck";

// Initialize Application Insights with instrumentation key from environment
const instrumentationKey = process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATION_KEY || '';
initializeAppInsights(instrumentationKey);

// Initialize Google Analytics
// GA script is loaded in index.html, this initializes it with user context
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    initializeGA();
    initializeClarity();
  });
}

function App() {
  useAppVersionCheck();

  // const activeTheme = useSelector(themeConfig);
  const [initialTheme] = useState<Theme>(Default);

  // useEffect(() => {
  //   if (activeTheme.themeMode === "dark") {
  //     setInitialTheme(Dark);
  //   } else {
  //     setInitialTheme(Default);
  //   }
  // }, [activeTheme.themeMode]);

  return (
    <ClickTracker>
      <ThemeProvider theme={initialTheme}>
        <MUIThemeProvider theme={theme}>
          <BrowserRouter>
            <AppRouterWithTracking />
          </BrowserRouter>
        </MUIThemeProvider>
      </ThemeProvider>
    </ClickTracker>
  );
}

// Wrapper component to enable page tracking hook
function AppRouterWithTracking() {
  useClarityPageTracking();
  useSessionIdleTimeout();
  return <AppRouter />;
}

export default App;
